import React, { useEffect, useState } from "react";
import NoData from "../../../asset/images/No data available.svg";
import upArrow from "../../../asset/images/up-arrow.svg";
import downArrow from "../../../asset/images/down-arrow-red.svg";
import Loader from "../../Common/Loader";
import {
  // aboveOneLacs,
  forToFix,
  // numDifferentiation,
  numDifferentiationWithoutSymbol,
  valueConverterLacCr,
  // numberFormat,
  // numDifferentiation,
} from "../../../CommonMethhods/CovertRupees";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import { Constants } from "../../../CommonMethhods/Constants";

function Snapshot(props) {
  const title = props.title;
  const dataTarget = props.dataTarget;
  const snapshotData = props.snapshotData;
  const snapshotOverall = snapshotData?.overall;
  const snapshotDiffValue = snapshotData?.diff;
  const snapshotDiffPercentage = snapshotData?.diffper;
  const onClick = props?.onClick;

  const ChartEq = props.chartEq;
  const ChartFno = props.chartFno;
  const ChartTotal = props.chartTotal;
  const forChartEqPercent = (ChartEq / ChartTotal) * 100;
  const forChartFnoPercent = (ChartFno / ChartTotal) * 100;
  let Overall;
  let DiffValue;

  const showMTFModal = props.showMTFModal;
  const setShowMTFModal = props.setShowMTFModal;

  const setShowRevModal =props.setShowRevModal;
  const showRevModal = props.showRevModal;

  const setShowAumModal =props.setShowAumModal;
  const showAumModal = props.showAumModal;

  const setShowTurnoverModal =props.setShowTurnoverModal;
  const showTurnoverModal = props.showTurnoverModal;

  const loader = props.loader;
  const overall =
    title === "Client Snapshot"
      ? "Acquired client"
      : "Overall " + title.split(" ")[0];

  const time = props.businessFilter;

  const duration = time.split("l")[0];

  if (props.isActive === true) {
    {
      Overall =
        snapshotOverall === undefined || null
          ? "0"
          : valueConverterLacCr(snapshotOverall);
      DiffValue =
        snapshotDiffValue === undefined || null
          ? "0"
          : valueConverterLacCr(snapshotDiffValue);
    }
  } else {
    Overall = snapshotOverall === undefined || null ? "0" : snapshotOverall;
    DiffValue =
      snapshotDiffValue === undefined || null ? "0" : snapshotDiffValue;
  }
  console.log(snapshotOverall, "snapshotOverall")
  const showSnaphotData = () => {
    return (
      <>
        <div className="block1-data">
          <div className="block1-data-display data-block-spansot">
            {/* snapshot overall value */}
            <div>
              {/* <h2 className="ovr-all" title={snapshotOverall}>{Overall}</h2> */}

              {/* <div>
                <h2 title={snapshotOverall}>{Overall}</h2>
                <h2>{overall}</h2>
              </div> */}
              <div className="overall-snap-value change-str">
                <h3
                  // className={
                  //   snapshotDiffValue === 0
                  //     ? "text-muted"
                  //     : snapshotDiffValue < 0
                  //       ? "red-txt"
                  //       : "green-txt"
                  // }
                  className={`diff-value ${snapshotDiffValue === 0
                      ? "text-muted"
                      : snapshotDiffValue < 0
                        ? "red-txt"
                        : "green-txt"
                    }`}
                >
                  {snapshotDiffValue === 0 ? null : snapshotDiffValue < 0 ? (
                    <img src={downArrow} alt="Down Arrow" />
                  ) : (
                    <img src={upArrow} alt="Up Arrow" />
                  )}

                  {/* snapshot difference value */}
                  <b style={{fontSize:"12px",lineHeight:"8px"}}>{DiffValue}</b>
                </h3>
                <h3
                  className={
                    snapshotDiffPercentage === 0
                      ? "text-muted"
                      : snapshotDiffPercentage < 0
                        ? "red-txt"
                        : "green-txt"
                  }
                >
                  (
                  {snapshotDiffPercentage === undefined || null
                    ? "0"
                    : forToFix(snapshotDiffPercentage) + "%"}
                  )
                </h3>
              </div>
            </div>


            {/* snapshot difference value */}
            <div className="snap-value-title-wrap">
              
              <span
                className="tooltip123 business-val" style={{ textAlign: "start", width: "117px" }}
              >
                {Overall}
                {(snapshotOverall !== 0 && snapshotOverall !== "" && snapshotOverall !== null) &&
                  <span className="tooltiptext number-adjst"
                  >{snapshotOverall}</span>}
              </span>

              <h4 className="card-footer-name">{overall}</h4>
            </div>


          </div>

          {/* <p>
            {title === "MTF Book" ? null : duration}
          </p> */}
        </div>
      </>
    );
  };
  return (
    <>
      <div className="col-md-6 col-lg-3">
        <div className="block1 dashboard-card-ch">
          <div className="card-subtitle pd-rv" id="flush-headingOne">
            {/* <div className={`card-subtitle ${title !== "MTF Book" && title !== "Client Snapshot" ? "pd-rv" : ""
            }`} id="flush-headingOne"> */}
            <div className="title-wrap-snap">
              <h3 className="snap-header" >{title}</h3>
              {/* {(title !== "MTF Book" && title !== "Client Snapshot") && <span className="value-text-add">In Lacs</span>} */}
            </div>

            {/* {title !== "MTF Book" ? (
              <div
                className="accordion-button toggle-btn"
                type="button"
                data-toggle="collapse"
                data-target={dataTarget}
                aria-expanded="false"
                aria-controls="flush-collapseOne"
                onClick={onClick}
              // onClick={handleSnaphotTable}
              ></div>
            ) : (
              <div
                className="accordion-button toggle-btn"
                type="button"
                aria-controls="flush-collapseOne"
                aria-expanded={showMTFModal}
                onClick={() => setShowMTFModal((prev) => !prev)}
              ></div>
            )} */}


            {title === "MTF Book" ?

            <div
                className="accordion-button toggle-btn"
                type="button"
                aria-controls="flush-collapseOne"
                aria-expanded={showMTFModal}
                onClick={() => setShowMTFModal((prev) => !prev)}
              ></div>
              : 
              title === "Revenue Snapshot" ?
              <div
                className="accordion-button toggle-btn"
                type="button"
                // data-toggle="collapse"
                // data-target={dataTarget}
                aria-expanded={showRevModal}
                aria-controls="flush-collapseOne"
                onClick={()=> setShowRevModal((prev) => !prev)}
              // onClick={handleSnaphotTable}
              ></div>

              : title === "AUM Snapshot" ?
              <div
                className="accordion-button toggle-btn"
                type="button"
                aria-expanded={showAumModal}
                aria-controls="flush-collapseOne"
                onClick={()=> setShowAumModal((prev) => !prev)}
              ></div>

              :
              title === "Turnover Report" ?
              <div
                className="accordion-button toggle-btn"
                type="button"
                aria-expanded={showTurnoverModal}
                aria-controls="flush-collapseOne"
                onClick={()=> setShowTurnoverModal((prev) => !prev)}
              ></div>
              :
               <div
                className="accordion-button toggle-btn"
                type="button"
                data-toggle="collapse"
                data-target={dataTarget}
                aria-expanded="false"
                aria-controls="flush-collapseOne"
                onClick={onClick}
              // onClick={handleSnaphotTable}
              ></div>

            }

            </div>


          {loader ? (
            <div className="loader-alignment new-loader-cl">
              <Loader />
            </div>
          ) : (
            showSnaphotData()
          )}
        </div>
      </div>
    </>
  );
}

export default Snapshot;
